// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EMmS","question":"styles_question__5UFUt","description":"styles_description__31_Qc"};